export default "__VITE_ASSET__BLucC8jg__"